<script>
import {useCatalogStore} from "@js/store/CatalogStore.js";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";

export default {
    name: "CatalogSortBlock",
    components: {OnlyMobile, OnlyDesktop},
    setup() {
        const catalogStore = useCatalogStore()
        return {catalogStore}
    }
}
</script>

<template>
    <OnlyDesktop :maxSize="1024">
        <div class="flex gap-2 items-center font-medium">
            <div class="flex items-center gap-2">
                <div v-for="sortType in catalogStore.order_types"
                     @click.prevent="catalogStore.changeOrder(sortType.type)"
                     class="px-3 py-1 rounded text-sm  cursor-pointer"
                     :class="[sortType.type === catalogStore.filter.sort ? 'bg-baseColor font-medium text-white' : 'bg-gray-200 font-normal']">
                    {{ sortType.title }}
                </div>
            </div>
        </div>
    </OnlyDesktop>
    <OnlyMobile :maxSize="1024">
        <div>
            <select v-model="catalogStore.filter.sort"
                    class="border-0 bg-transparent text-gray-900 font-bold text-[13px] rounded-lg focus:ring-0 block p-0 max-w-min">
                <option :value="sortType.type" v-for="sortType in catalogStore.order_types">
                    {{ sortType.title }}
                </option>
            </select>
        </div>
    </OnlyMobile>
</template>

<style scoped lang="scss">

</style>
